import { Plugin } from 'vuex';
import { RootState } from '@/store/store';
import { AxiosError } from 'axios';

export const errorLogger: Plugin<RootState> = (store) => {
  store.subscribe((mutation) => {
    const { type } = mutation;
    if (type.endsWith('_ERROR')) {
      const error = mutation.payload as AxiosError | Error;
      const status = (error as AxiosError)?.response?.status;
      // 4xx are often expected user/validation flows — avoid console.error noise; still surface 5xx and network failures.
      if (typeof status === 'number' && status >= 400 && status < 500) {
        // eslint-disable-next-line no-console
        console.warn({ type, error, mutation });
      } else {
        // eslint-disable-next-line no-console
        console.error({ type, error, mutation });
      }
    }
  });
};
